import React, { useRef, useEffect } from "react";
import { useSelector } from "react-redux";
import { useInView } from "react-intersection-observer";
import { useGetTalkgroupsQuery } from "../features/api/apiSlice";
import useLiveScroll from "../Call/useLiveScroll";
import { groupCallsByDivider } from "./demoHelpers";
import DemoCallItem from "./DemoCallItem";

function DemoFeed({ callsData, activeCallId, activeCallTime, playCall, handleNewer, handleOlder, live, shortName, groupsData }) {
  const listRef = useRef();
  const { data: talkgroupsData } = useGetTalkgroupsQuery(shortName);
  const callsLoading = useSelector((s) => s.calls.loading);
  const hasMoreOlder = useSelector((s) => s.calls.hasMoreOlder);
  const hasMoreNewer = useSelector((s) => s.calls.hasMoreNewer);

  const { ref: loadOlderRef, inView: loadOlderInView } = useInView({ rootMargin: "400px 0px" });
  const { ref: loadNewerRef, inView: loadNewerInView } = useInView();

  const { following, newCallCount, jumpToLive } = useLiveScroll({
    listRef, callsData, activeCallId, activeCallTime,
  });

  useEffect(() => {
    if (loadNewerInView && !live && !callsLoading && hasMoreNewer && callsData && callsData.ids.length > 0) handleNewer();
  }, [loadNewerInView, live, callsLoading, hasMoreNewer, callsData]);
  useEffect(() => {
    if (loadOlderInView && !callsLoading && hasMoreOlder && callsData && callsData.ids.length > 0) handleOlder();
  }, [loadOlderInView, callsLoading, hasMoreOlder, callsData]);

  const buckets = groupCallsByDivider(callsData);

  return (
    <div className="demo-feed-wrap">
      {!following && newCallCount > 0 && (
        <button className="demo-new-calls" onClick={jumpToLive}>
          ↑ {newCallCount === 1 ? "New call" : `${newCallCount} new calls`}
        </button>
      )}
      <div ref={loadNewerRef} />
      <table className="demo-feed" ref={listRef}>
        <tbody>
          {buckets.map((bucket) => (
            <React.Fragment key={bucket.label + bucket.callIds[0]}>
              <tr className="demo-divider"><td colSpan={5}>{bucket.label}</td></tr>
              {bucket.callIds.map((id) => (
                <DemoCallItem
                  key={id}
                  call={callsData.entities[id]}
                  activeCall={id === activeCallId}
                  talkgroupsData={talkgroupsData}
                  groupsData={groupsData}
                  onClick={playCall}
                />
              ))}
            </React.Fragment>
          ))}
        </tbody>
      </table>
      <div ref={loadOlderRef} style={{ height: 50 }} />
    </div>
  );
}

export default DemoFeed;
